'use client';

import React from 'react';
import { Grid, GridItem } from '@skin-seoul/design-system';
import ProductCard from '@/components/products/ProductCard';
type RecentlyViewedListSkeletonProps = {
  length: number;
};
const RecentlyViewedListSkeleton = ({
  length
}: RecentlyViewedListSkeletonProps) => {
  return <Grid templateColumns={{
    base: 'repeat(2, minmax(0, 1fr))',
    desktop: 'repeat(5, minmax(0, 1fr))'
  }} tablet={{
    '& > *:nth-of-type(n+5)': {
      display: 'none'
    }
  }} desktop={{
    '& > *:nth-of-type(n+5)': {
      display: 'initial'
    }
  }} gap={3} width="100%" data-sentry-element="Grid" data-sentry-component="RecentlyViewedListSkeleton" data-sentry-source-file="RecentlyViewedListSkeleton.tsx">
      {Array.from({
      length
    }).map((_, index) => <GridItem key={index}>
          <ProductCard.Skeleton orientation="vertical" width="100%" />
        </GridItem>)}
    </Grid>;
};
export default RecentlyViewedListSkeleton;